import { gql } from "@apollo/client";

const USER_QUERY = {
  GET_USERS: gql`
    query usersList(
      $page: Int!
      $limit: Int!
      $searchQuery: String
      $userType: String
      $status: UserStatusEnum
      $order: SortOrderEnum!
      $column: UserColumnsEnum!
    ) {
      usersList(
        page: $page
        limit: $limit
        searchQuery: $searchQuery
        userType: $userType
        status: $status
        sortBy: { order: $order, column: $column }
      ) {
        list {
          uid
          userType
          email
          displayName
          createdOn
          status
          lastLoginAt
          totalLovitz
          userProfile {
            firstName
            lastName
            isActive
          }
        }
        page
        limit
        totalCount
      }
    }
  `,
  GET_USER: gql`
    query GetUser($id: String!) {
      getOneUser(id: $id) {
        userType
        email
        displayName
        profileImage
        status
        warningsCount
        collabersCount
        clipsCount
        userProfile {
          firstName
          lastName
          isActive
          phoneNumber {
            phNumber
            phoneCode
          }
        }
      }
    }
  `,
  CREATE_USER: gql`
    mutation (
      $fullName: String!
      $email: String!
      $createdDate: String!
      $userName: String!
      $lastLoginDate: String!
      $status: String!
      $warnings: Int!
      $clipsShared: Int!
      $collabers: Int!
      $phone: String!
    ) {
      createAdmin(
        fullName: $fullName
        email: $email
        createdDate: $createdDate
        userName: $userName
        lastLoginDate: $lastLoginDate
        status: $status
        clipsShared: $clipsShared
        collabers: $collabers
        warnings: $warnings
        phone: $phone
        userType: "Admin"
      ) {
        fullName
        email
        createdDate
        userName
        lastLoginDate
        status
        clipsShared
        collabers
        warnings
        phone
        userType
      }
    }
  `,
  STATUS_ACTION: gql`
    mutation (
      $id: String!
      $status: UserStatusEnum!
      $reason: String!
      $files: [String]
    ) {
      updateUserStatus(
        id: $id
        status: $status
        reason: $reason
        files: $files
      ) {
        uid
        userType
      }
    }
  `,
  GET_ARCHIVED_USERS: gql`
    query archivedUsersList(
      $page: Int!
      $limit: Int!
      $searchQuery: String
      $userType: String
      $order: SortOrderEnum!
      $column: UserColumnsEnum!
    ) {
      archivedUsersList(
        page: $page
        limit: $limit
        searchQuery: $searchQuery
        userType: $userType
        sortBy: { order: $order, column: $column }
      ) {
        list {
          uid
          userType
          email
          displayName
          createdOn
          status
          lastLoginAt
          totalLovitz
          userProfile {
            firstName
            lastName
            isActive
          }
        }
        page
        limit
        totalCount
      }
    }
  `,
  GET_ACTIVITY_LOG: gql`
    query activityLogsList($page: Int!, $userId: String!) {
      activityLogsList(page: $page, userId: $userId, limit: 10) {
        list {
          action
          createdOn
          metaData
          reportId
        }
        page
        limit
        totalCount
      }
    }
  `,
};
export default USER_QUERY;
